import './Preview.less';
import { useEffect, useRef, useState } from 'react';
import GLBViewer from '@/components/GLBViewer/GLBViewer';
import close from '@/assets/preview/texture-close.png';
import open from '@/assets/preview/texture-open.png';
import { Spin } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { fileExtension } from '@/utils/file';
import { projectController, SDService } from '@/api';
import { reportData } from '@/utils/trackingPoint';
import UploadProgress from '@/components/UploadProgress/UploadProgress';

export default function Preivew() {
  // const { search } = useLocation(); // 获取 ? 后面的内容
  // const query = new URLSearchParams(search);
  const [loading, setLoading] = useState(true);
  const [modelStyle, setModelStyle] = useState(2);
  const [progress, setProgress] = useState(0);
  const [showTask, setShowTask] = useState(false);

  const { projectId } = useParams(); // 获取路径参数
  const glbViewerRef = useRef(null);

  const [url, setUrl] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    queryDetail();
  }, []);
  const download = () => {
    reportData('download-model');
    const a = document.createElement('a');
    a.href = url;
    a.download = 'model.glb';
    a.click();
  };

  const queryDetail = async () => {
    const res = await projectController.detail({
      projectId: projectId,
    });

    if (res.code == 0) {
      if (res.data.meshUrl) {
        setShowTask(false);
        setUrl(res.data.meshUrl);
      } else {
        setShowTask(true);
        queryTask(res.data.taskId);
      }
    }
  };

  const queryTask = (task_id) => {
    const interval = setInterval(async () => {
      const taskRes = await SDService.task_status_3d(task_id);
      if (taskRes.code === 0) {
        const data = taskRes.data;
        const progress = data.progress;
        setProgress(progress);
        if (data.status === 'success') {
          clearInterval(interval);
          sessionStorage.setItem('preview_url', data.modelUrl);
          queryDetail();
        }
      } else {
        clearInterval(interval);
      }
    }, 2000);
  };

  const editTexture = async () => {
    reportData('edit-texture');
    const res = await projectController.enterTexture(projectId);
    if (res.code === 0) {
      navigate('/texture/' + projectId);
    }
  };
  const changeModelStyle = async (style) => {
    if (style === 1) {
      glbViewerRef.current.applyWhite();
    } else {
      glbViewerRef.current.applyInit();
    }
    setModelStyle(style);
  };
  return (
    <div className="preivew">
      {url ? (
        <GLBViewer
          onLoadFinish={() => {
            setLoading(false);
          }}
          ref={glbViewerRef}
          format={url ? fileExtension(url) : ''}
          url={url}
          style={{ width: '100%', height: '100%' }}></GLBViewer>
      ) : (
        <></>
      )}
      <div className="bottom-tabs">
        <img
          src={modelStyle === 1 ? open : close}
          onClick={() => {
            changeModelStyle(1);
          }}></img>
        <img
          src={modelStyle === 2 ? open : close}
          onClick={() => {
            changeModelStyle(2);
          }}></img>
      </div>
      <div className="right-btns">
        {/* <Select className="select" defaultValue={'balance'}>
          <Select.Option value="balance">Balance</Select.Option>
        </Select> */}
        <div className="download-btn" onClick={download}>
          Download model
        </div>
        <div className="edit-btn" onClick={editTexture}>
          Edit Texture
        </div>
      </div>

      {showTask && (
        <div className="preivew-spin">
          <UploadProgress percent={progress} title="Loading..."></UploadProgress>
        </div>
      )}

      {!showTask && loading ? (
        <div className="preivew-spin">
          <Spin
            style={{ backgroundColor: 'rgb(27,27,27)', marginTop: 20 }}
            spinning={loading}></Spin>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
